declare const WEBPACK_MODE :string;

/* eslint-disable-next-line no-extra-parens */
export const webpack_mode = typeof (WEBPACK_MODE as any) === "string"
  ? WEBPACK_MODE
  : "development";

export const webpackMode = webpack_mode;

